import SupportBody from "./SupportBody"

export default  SupportBody;



// WEBPACK FOOTER //
// ./src/components/App/SupportDashboard/SupportBody/index.js